import axios from "axios";
import { Timestamp } from "firebase/firestore";
import Phaser from "phaser";
import { data, dbObject, finance, areAssetsLoaded } from "../data";
import { createButton } from "../modules/createButton";
export default class Start extends Phaser.Scene {
  data;
  width;
  height;
  /** @type {Phaser.GameObjects.Image} */
  start;
  constructor() {
    super("start");
  }
  preload() {
    this.load.image("startBg", "./assets/background/Bamboo_Forest_BG_Day.png");
    this.load.image("title", "./assets/background/title.png");
    this.load.image("start", "./assets/buttons/Start.png");
  }
  init() {
    this.data = data();
    this.width = this.sys.canvas.width;
    this.height = this.sys.canvas.height;
  }
  async create() {
    finance.freePlay = 3;
    finance.coins = 50;
    this.createBg();
    this.createTitle();
    this.addButton();
  }
  update(t, dt) {}
  createBg() {
    this.background = this.add
      .image(0, 0, "startBg")
      .setOrigin(0)
      .setDisplaySize(this.sys.canvas.width, this.sys.canvas.height);
  }
  createTitle() {
    this.add
      .image(this.width / 2, this.height * 0.3, "title")
      .setScale(this.data.scaleX);
  }
  addButton() {
    createButton(
      this,
      this.width / 2,
      this.height * 0.6,
      "start",
      0.4 * this.data.scaleX,
      async () => {
        finance.coins = 50;
        finance.freePlay = 3;
        finance.skinned = false;
        finance.level = 1;
        try {
          dbObject.timeStarted = Timestamp.now();
          const res = await axios.get("https://geolocation-db.com/json/", {
            method: "GET",
            mode: "no-cors",
            withCredentials: false,
          });
          dbObject.ipAddress = res.data.IPv4;
          dbObject.geoData = res.data;
        } catch (error) {
          console.log(error.message);
          dbObject.ipAddress = "ip couldn't be gotten from the server";
          dbObject.geoData = "geo couldn't be gotten from the server";
        }
        if (areAssetsLoaded.value) {
          this.scene.start("instructions");
        } else {
          this.scene.start("preload");
        }
      }
    );
  }
}
